import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="py-10 md:py-16 px-4 bg-gradient-to-b from-cream to-white" data-id="element-56">
      <div className="max-w-4xl mx-auto" data-id="element-57">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 30
      }} transition={{
        duration: 0.6
      }} data-id="element-58">
          <div className="bg-white rounded-lg shadow-2xl p-6 md:p-12 border-2 md:border-4 border-sage" data-id="element-59">
            <div className="flex justify-center mb-4 md:mb-6" data-id="element-60">
              <div className="bg-sage-light rounded-full p-4 md:p-6" data-id="element-61">
                <ShieldCheckIcon className="w-12 h-12 md:w-16 md:h-16 text-dark-green" aria-hidden="true" data-id="element-62" />
              </div>
            </div>

            <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl text-warm-brown mb-4 md:mb-6 text-center px-2" data-id="element-63">
              🛡️ Garantía Total de 60 Días — Sin Preguntas
            </h2>

            <div className="prose prose-base md:prose-lg max-w-none text-gray-700 space-y-3 md:space-y-4" data-id="element-64">
              <p className="text-base md:text-lg" data-id="element-65">
                Tienes{' '}
                <strong className="text-gray-900" data-id="element-66">60 días completos</strong>{' '}
                para explorar cada módulo, preparar cada receta y experimentar
                los protocolos en tu propia cocina.
              </p>
              <p className="text-base md:text-lg" data-id="element-67">
                Si en algún momento dentro de esos 60 días sientes que este
                sistema no es para ti — por cualquier razón, sin necesidad de
                explicarla — simplemente escríbenos y te devolvemos cada centavo
                de tu inversión.
              </p>
              <div className="bg-sage-light/30 border-l-4 border-dark-green p-4 md:p-6 rounded-lg my-4 md:my-6" data-id="element-68">
                <p className="font-bold text-gray-900 text-lg md:text-xl mb-2" data-id="element-69">
                  Sin preguntas. Sin formularios complicados. Sin demoras.
                </p>
              </div>
              <p className="text-base md:text-lg" data-id="element-70">
                A $6.39 el riesgo es prácticamente inexistente.
              </p>
              <p className="text-base md:text-lg" data-id="element-71">
                Pero la garantía existe porque creemos con absoluta convicción
                en lo que está dentro de este libro — y porque mereces probarlo
                sin ningún tipo de presión ni riesgo financiero.
              </p>
              <p className="text-lg md:text-xl font-bold text-terracotta text-center mt-6 md:mt-8" data-id="element-72">
                El riesgo es completamente nuestro. La salud es completamente
                tuya.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}